const features = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '24小时不间断监测，热点事件发生后15分钟内完成首发，比微博热搜平均快30分钟。',
  },
  {
    id: 2,
    icon: 'ri-database-2-line',
    title: '海量内容',
    desc: '累计收录10万+条爆料，覆盖影视、音乐、综艺、网红、社会热点等全品类娱乐资讯。',
  },
  {
    id: 3,
    icon: 'ri-search-eye-line',
    title: '深度挖掘',
    desc: '专业编辑团队对每条爆料进行多方交叉验证，提供事件背景、人物关系等深度分析内容。',
  },
  {
    id: 4,
    icon: 'ri-user-heart-line',
    title: '用户至上',
    desc: '无弹窗广告、无强制跳转、无诱导分享，纯净的阅读体验让你专注吃瓜本身。',
  },
  {
    id: 5,
    icon: 'ri-secure-payment-line',
    title: '安全访问',
    desc: '全站HTTPS加密传输，不收集用户隐私，不强制注册，匿名访问也能享受完整体验。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">平台特色</h2>
          <p className="text-foreground-500 text-sm">为什么千万吃瓜群众选择我们</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5 max-w-6xl mx-auto">
          {features.map((f, i) => (
            <div
              key={f.id}
              className={`rounded-2xl p-6 border border-background-200/70 transition-all duration-200 hover:-translate-y-1 ${
                i === 0
                  ? 'bg-primary-50 border-primary-200/70'
                  : i === 1
                  ? 'bg-accent-50 border-accent-200/70'
                  : 'bg-background-100'
              }`}
            >
              <div
                className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${
                  i === 0
                    ? 'bg-primary-500 text-background-50'
                    : i === 1
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-secondary-100 text-secondary-600'
                }`}
              >
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}